import { z } from "zod";

export const createNudgeSchema = z.object({
  receiverId: z.string().min(1, "Receiver is required"),
  message: z
    .string()
    .max(500, "Message must be 500 characters or less")
    .optional(),
});

export type CreateNudgeInput = z.infer<typeof createNudgeSchema>;

// ─── Plotlounge facilitator eligibility (issue #282) ───────────────────────

export const inviteFacilitatorSchema = z
  .object({
    userId: z.string().min(1).optional(),
    email: z.string().email().optional(),
  })
  .refine((data) => Boolean(data.userId || data.email), {
    message: "Either userId or email is required",
  });

export type InviteFacilitatorInput = z.infer<typeof inviteFacilitatorSchema>;

export const revokeFacilitatorSchema = z.object({
  mode: z.enum(["graceful", "force"]),
  reason: z.string().max(500).optional(),
});

export type RevokeFacilitatorInput = z.infer<typeof revokeFacilitatorSchema>;

// ─── Plotlounge room assignment (issue #283) ───────────────────────────────

export const assignRoomFacilitatorSchema = z.object({
  userId: z.string().min(1, "userId is required"),
});

export type AssignRoomFacilitatorInput = z.infer<
  typeof assignRoomFacilitatorSchema
>;

export const unassignRoomFacilitatorSchema = z.object({
  reason: z.string().max(500).optional(),
});

export type UnassignRoomFacilitatorInput = z.infer<
  typeof unassignRoomFacilitatorSchema
>;
